import { render, staticRenderFns } from "./DCard.vue?vue&type=template&id=2f08d2ca"
import script from "./DCard.vue?vue&type=script&lang=js"
export * from "./DCard.vue?vue&type=script&lang=js"
import style0 from "./DCard.vue?vue&type=style&index=0&id=2f08d2ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports